module.exports = __webpack_public_path__ + "img/calendar.6ccbe64a.png";